import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { VStack } from '@chakra-ui/react'
import { useValidateUserStep } from 'context'
import { ValidateUserParamsType } from 'context/ValidateUser'
import { themeColors } from 'theme'

import { WicarLogo } from 'components/SVGS'

import { StepOne } from './StepOne'
import { StepTwo } from './StepTwo'

type ValidateUserNavigateProps = { validateUser: ValidateUserParamsType }

export const ValidateUser = () => {
  const location = useLocation()

  const { container: { gradientColor: { gradientOne, gradientTwo, gradientThree } } } = themeColors
  const {
    setStateByParams, setLoading, forwardSms, backTo, validateUserState: { state: { step } },
  } = useValidateUserStep()
  const [validateUser, setValidateUser] = useState<ValidateUserParamsType | null>(null)

  useEffect(() => {
    let validateUser = null

    if (location.state) ({ validateUser } = location.state as ValidateUserNavigateProps)

    validateUser && setValidateUser(validateUser)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  useEffect(() => {
    if (validateUser !== null) {
      const { email, password, phoneNumber } = validateUser.user

      forwardSms({ email, password, phoneNumber })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateUser])

  useEffect(() => {
    if (step > 2) backTo(2)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step])

  useEffect(() => {
    if (validateUser) {
      const { isLogin, user: { email, password, phoneNumber } } = validateUser

      setLoading()
      setStateByParams({ isLogin, user: { email, password, phoneNumber } })
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateUser])

  return (
    <VStack
      minH={'100vh'}
      minW={'100vw'}
      bgGradient={`linear(to-b, ${gradientOne}, ${gradientTwo}, ${gradientThree})`}>
      <VStack
        flex={1}
        mx="auto"
        w={'full'}
        maxW={{ base: '90%', md: '550px' }}
        h={'fit-content'}
        rounded='2xl'
        p={{ base: 2, md: 4 }}
        justifyContent='center'
        alignItems='center'
        spacing={{ base: 4, md: '70px' }}>
        <VStack>
          <WicarLogo width={200} height={50} />
        </VStack>
        {validateUser && <VStack w={'full'} justifyContent={'center'} alignItems={'center'} spacing={'60px'}>
          <VStack w={'full'}>
            {step === 1 && <StepOne />}
            {step === 2 && <StepTwo />}
          </VStack>
        </VStack>}
      </VStack>
    </VStack>
  )
}
